import {Skeleton} from '@mui/material';
import React from 'react';

import {DataInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {OdontoSpecialtiesSectionProps} from './types';

const {guideDetails} = translations['pt-br'].privateFlow.guideFlow;

export function OdontoSpecialtiesSection({data, hasError, loading}: OdontoSpecialtiesSectionProps) {
	if (loading) {
		return <Skeleton width={200} />;
	}

	if (hasError || !data) {
		return null;
	}

	const emptySpecialties = data.especialidades.length === 0;

	if (emptySpecialties) {
		return null;
	}

	const text = data.especialidades.map(specialty => specialty.descricao).join(', ');

	return (
		<DataInfo
			removeItemTextMargin
			iconName="tooth-outline"
			primaryText={guideDetails.specialties}
			primaryTextColor="text.primary"
			primaryTextFontSize="1rem"
			secondaryText={formatText(text)}
			secondaryTextColor="text.secondary"
			secondaryTextFontSize="0.875rem"
		/>
	);
}
